import React from 'react';
import { AlertTriangle } from 'lucide-react';
import FinanceTooltipPanel from '../../../financeShared/FinanceTooltipPanel';

const TooltipValores = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const valorTotal = Number(data.valorTotal) || 0;
    const valorPago = Number(data.valorPago) || 0;
    const valorAberto = Number(data.valorAberto) || 0;
    const totalContas = Number(data.totalContas) || 0;
    const contasVencidas = Number(data.contasVencidas) || 0;

    const rows = [
      { id: 'total', label: 'Valor Total', dotColor: 'var(--chart-1, #3B82F6)', textClass: 'text-[color:var(--text-primary)]', value: `R$ ${valorTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { id: 'pago', label: 'Valor Pago', dotColor: 'var(--status-good, #10B981)', textClass: 'text-[color:var(--status-good,var(--text-primary))]', value: `R$ ${valorPago.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { id: 'aberto', label: 'Valor em Aberto', dotColor: 'var(--status-bad, #EF4444)', textClass: 'text-[color:var(--status-bad,var(--text-primary))]', value: `R$ ${valorAberto.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
    ];
    
    return (
      <FinanceTooltipPanel
        title={data.nomeCompleto || label}
        rows={rows}
        totalText={`Total: ${totalContas} conta${totalContas !== 1 ? 's' : ''} nesta conta bancária`}
        footerNode={
          contasVencidas > 0 ? (
            <div className="text-xs mt-2 pt-2 border-t border-[color:var(--border)] text-[color:var(--status-bad,var(--text-primary))] inline-flex items-center gap-1.5">
              <AlertTriangle className="h-3.5 w-3.5" />
              {contasVencidas} vencida{contasVencidas !== 1 ? 's' : ''}
            </div>
          ) : null
        }
      />
    );
  }
  return null;
};

export default TooltipValores;



